import { observer } from "mobx-react-lite";
import React from "react";
import { DateFilter } from "./DateFilter";
import { LanaguagesFilter } from "./LanugagesFilter";
import { SourcesFilter } from "./SourcesFilter";

export const ReportViewFilter = observer(() => (
    <div className="my-2 rounded-lg bg-white p-2 shadow-lg">
        <div className="font-bold">Filters</div>
        <div className="flex flex-row flex-wrap items-center justify-between">
            <LanaguagesFilter />
            <DateFilter />
            <SourcesFilter />
        </div>
    </div>
));
